<template>
  <div>
    <div class="container-fluid container-header">
      <div class="app container-xl app-container d-flex align-items-center al justify-content-between">
        <div class="icone-svg">
          <svg v-if="showBtnVoltar"  @click="voltar()" xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M16.0682 20.5C15.8365 20.5 15.6121 20.418 15.4414 20.2701L7.30762 13.2193C6.91739 12.88 6.89544 12.3109 7.25884 11.9466C7.27104 11.9329 7.28567 11.9216 7.3003 11.9079L15.4365 4.73644C15.8023 4.41088 16.3828 4.42226 16.734 4.76603C16.7413 4.77286 16.7486 4.77969 16.7535 4.78652C17.1023 5.15079 17.0779 5.70629 16.6998 6.04324L9.30996 12.559L16.695 18.9519C17.0754 19.282 17.1023 19.8443 16.7559 20.2086C16.5828 20.3907 16.3316 20.4977 16.0682 20.5Z" fill="black"/>
          </svg>
        </div>
        <p class="m-0">{{this.titulo}}</p>
        <div v-on:click="btnFechar()" >
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" viewBox="0 0 24 25" fill="none">
            <path d="M16.8411 18.3529C17.1242 18.5684 17.53 18.5468 17.7886 18.2883C18.0707 18.0062 18.0707 17.5488 17.7886 17.2668L13.0216 12.4997L17.7882 7.73311L17.8528 7.65914C18.0683 7.37603 18.0468 6.97019 17.7882 6.71162C17.5061 6.42954 17.0488 6.42954 16.7667 6.71162L12.0001 11.4783L7.23319 6.71137L7.15922 6.64673C6.8761 6.43126 6.47027 6.4528 6.2117 6.71137C5.92962 6.99345 5.92962 7.45079 6.2117 7.73286L10.9786 12.4997L6.21131 17.267L6.14667 17.341C5.9312 17.6241 5.95274 18.0299 6.21131 18.2885C6.49339 18.5706 6.95073 18.5706 7.2328 18.2885L12.0001 13.5212L16.7671 18.2883L16.8411 18.3529Z" fill="black"/>
          </svg>
        </div>
      </div>
    </div>
    <Modal
        modal-id="modalfechar"
        :show-close-button="false"
        title="Quer sair da biometria?"
        text="Você ainda não terminou de confirmar sua identidade e suas informações ainda não estão salvas"
        button-close-text="voltar"
        button-confirm-text="sair"
        v-bind:callback-confirm-button="sairDoApp"
        v-bind:callback-close-button="fecharModal"
    ></Modal>
  </div>

</template>

<script>
import Modal from "./Modal";

export default {
  name: "HeaderDefault",
  components: {Modal},
  computed:{
    titulo:function (){
      if(this.loadingStatus){
        return "Confirmar identidade";
      }
      return this.$store.state.titulo;
    },
    loadingStatus() {
      return this.$store.getters.loadingStatus
    },
    showBtnVoltar(){
      return (this.$route.name === 'TermoUso');
    }
  },
  methods:{
    btnFechar:function (){
      if(this.$route.name === 'TermoUso'){
        this.$router.replace({name: 'ConfirmarIdentidade'});
      }else{
        $('#modalfechar').modal()
      }
    },
    sairDoApp:function (){
      sessionStorage.clear();
      this.$store.dispatch('resetState');
      window.close();
      window.setTimeout(()  => window.open("about:blank", "_self"),400);
    },
    fecharModal:function (){
    },
    voltar:function (){
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped>
  .icone-svg{
    width: 24px;
    height: 25px;
  }
  .container-fluid > .app{
    padding: 0;
  }
  .container-header{
    height: 3.5rem;
    padding-top: 1rem;
    margin-bottom: 1.25rem;
  }
  .container-header p{
    font-family: 'VivoType', Sans-Serif;
    color: var(--text-text-secondary, #666);
    text-align: center;
    font-feature-settings: 'clig' off, 'liga' off;
    font-size: 18px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
  .btn-fechar{
    float: left;
    position: relative;
    font-size: 1.125rem;
    color: var(--text-text-primary, #000);
  }

  @media (max-height: 550px) {
    .container-header{
      height: 3rem;
      padding-top: 0.8rem;
      margin-bottom: 0.8rem;
    }
  }
</style>
<style>
#modalfechar{
  transform: translateY(25%);
}
#modalfechar .modal-header{
  padding-bottom: 0;
  margin-bottom: 0;
  border: none;
}
#modalfechar .modal-body{
  padding-bottom: 0;
  margin-bottom: 0;
  padding-top: 2rem;
}
#modalfechar .modal-footer{
  padding-top: 0;
  margin-top: 0;
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/shared/HeaderDefault.vue